export const steps = [
  require('../Introduction').default,
  require('./step1').default,
  require('./step2').default,
  require('./step3').default,
  require('./step4').default,
  require('./step5').default,
  require('./step6').default,
  require('./step7').default,
  require('./step8').default,
  require('./step9').default,
  require('./step10').default,
  require('./step11').default,
  require('./step12').default,
  require('./step13').default,
  require('./step14').default,
  require('./step15').default,
  require('./step16').default,
  require('./step17').default,
  require('./step18').default,
  require('./step19').default,
  require('./step20').default,
  require('./step21').default,
  require('./step22').default,
  require('./step23').default,
  require('./step24').default,
];
